import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaProdutoResponse } from '../../responses/scanntech/lista-produto.response';

@Injectable({
  providedIn: 'root',
})
export class ProdutoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public getProdutos(filtro?: string): Observable<ListaProdutoResponse> {
    let url = environment.urlApiScanntech + 'Produto';
    const params: string[] = [];
    if (filtro) {
      params.push(`filtro=${encodeURIComponent(filtro)}`);
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    return this.httpClient
      .get<ListaProdutoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
